import g from "./ghl-ui.es1173.js";
import h from "./ghl-ui.es1157.js";
const s = (e) => {
  const {
    heightSmall: r,
    heightMedium: t,
    heightLarge: l,
    textColor1: a,
    errorColor: o,
    warningColor: i,
    lineHeight: n,
    textColor3: m
  } = e;
  return Object.assign(Object.assign({}, g), {
    blankHeightSmall: r,
    blankHeightMedium: t,
    blankHeightLarge: l,
    lineHeight: n,
    labelTextColor: a,
    asteriskColor: o,
    feedbackTextColorError: o,
    feedbackTextColorWarning: i,
    feedbackTextColor: m
  });
}, c = {
  name: "Form",
  common: h,
  self: s
}, C = c;
export {
  C as default,
  s as self
};
